// src/utils/fireManagement.js

import mapboxgl from "mapbox-gl";
import { createFireInDatabase, deleteFireFromDatabase, fetchExistingFiresApi } from "../utils/api";
import swal from 'sweetalert';
import { decode as base64_decode } from "base-64";
import "../views/home.css";
import '../components/manage-helicopter-card.css'

export const handleRightClick = (map, e, selectedFireRef, setSelectedFire) => {
    console.log("Right click event:", e);
  e.preventDefault();
  const { lng, lat } = e.lngLat;

  const features = map.queryRenderedFeatures(e.point, { layers: ['fire-markers-layer'] });
  if (features.length > 0) return;

  const popup = new mapboxgl.Popup({ closeButton: false, closeOnClick: true })
    .setLngLat([lng, lat])
    .setHTML('<button id="report-fire-btn" class="report-fire-btn">Report a fire</button>')
    .addTo(map);

  document.getElementById('report-fire-btn').addEventListener('click', async () => {
    const { fireId, createdBy } = await createFireInDatabase(lng, lat);
    addFireMarker(map, lng, lat, fireId, createdBy, selectedFireRef, setSelectedFire);
    popup.remove();
  });
};

export const addFireMarker = async (map, lng, lat, existingFireId = null, createdBy = null, selectedFireRef, setSelectedFire) => {
  try {
    let fireId = existingFireId || await createFireInDatabase(lng, lat);

    const existingMarker = document.querySelector(`.fire-marker[data-fire-id="${fireId}"]`);
    if (existingMarker) return;

    const el = createFireIcon();
    el.setAttribute('data-fire-id', fireId);
    if (createdBy) el.setAttribute('data-created-by', createdBy);

    const newFireMarker = new mapboxgl.Marker({ element: el, anchor: 'center' })
      .setLngLat([lng, lat])
      .addTo(map);

    el.addEventListener('click', (event) => {
      event.stopPropagation();
      handleFireClick(newFireMarker, event, selectedFireRef, setSelectedFire);
    });

    const userRole = base64_decode(localStorage.getItem("role"));
    const userId = base64_decode(localStorage.getItem("userId"));

    if (userRole === "admin" || (userRole === "user" && createdBy === userId)) {
      const deleteBtn = document.createElement('div');
      deleteBtn.className = 'delete-fire-btn';
      deleteBtn.innerHTML = '&times;'; // Use Unicode entity for the multiplication sign
      deleteBtn.addEventListener('click', (e) => {
        e.stopPropagation();
        deleteFireMarker(newFireMarker);
      });

      setTimeout(() => {
        const markerElement = newFireMarker.getElement();
        markerElement.appendChild(deleteBtn);
      }, 0);
    }

  } catch (error) {
    console.error("Failed to add fire marker:", error);
    swal("Error", "Failed to add fire marker. Please try again.", "error");
  }
};

export const handleFireClick = (fireMarker, event, selectedFireRef, setSelectedFire) => {
    event.stopPropagation();

  if (selectedFireRef.current === fireMarker) {
    setSelectedFire(null);
    fireMarker.getElement().classList.remove('selected-fire');
  } else {
    if (selectedFireRef.current) {
      selectedFireRef.current.getElement().classList.remove('selected-fire');
    }
    setSelectedFire(fireMarker);
    fireMarker.getElement().classList.add('selected-fire');
  }
};

export const createFireIcon = () => {
  const el = document.createElement('div');
  el.className = 'fire-marker';
  el.style.backgroundImage = 'url(/favicone.ico)';
  el.style.width = '45px';
  el.style.height = '45px';
  el.style.backgroundSize = 'contain';
  el.style.backgroundRepeat = 'no-repeat';
  el.style.backgroundPosition = 'center';
  return el;
};

export const deleteFireMarker = async (fireMarker) => {
  try {
    const fireId = fireMarker.getElement().getAttribute('data-fire-id');
    const createdBy = fireMarker.getElement().getAttribute('data-created-by');
    const userRole = base64_decode(localStorage.getItem("role"));
    const userId = base64_decode(localStorage.getItem("userId"));

    if (userRole === "admin" || (userRole === "user" && createdBy === userId)) {
      await deleteFireFromDatabase(fireId);
      fireMarker.remove();
    } else {
      swal("Error", "You don't have permission to delete this fire.", "error");
    }
  } catch (error) {
    console.error("Failed to delete fire marker:", error);
    swal("Error", "Failed to delete fire marker. Please try again.", "error");
  }
};

export const fetchExistingFires = async (map, selectedFireRef, setSelectedFire) => {
  try {
    const incomingFires = await fetchExistingFiresApi();

    const existingFireMarkers = document.querySelectorAll('.fire-marker');
    const existingFireIds = new Set(Array.from(existingFireMarkers).map(marker => marker.getAttribute('data-fire-id')));

    incomingFires.forEach(fire => {
      if (!existingFireIds.has(fire.id.toString())) {
        addFireMarker(map, fire.longitude, fire.latitude, fire.id, fire.createdBy, selectedFireRef, setSelectedFire);
      }
    });

    const incomingFireIds = new Set(incomingFires.map(fire => fire.id.toString()));
    existingFireMarkers.forEach(markerElement => {
      const fireId = markerElement.getAttribute('data-fire-id');
      if (!incomingFireIds.has(fireId)) {
        const marker = map.getCanvasContainer().querySelector(`[data-fire-id="${fireId}"]`);
        if (marker) {
          new mapboxgl.Marker(marker).remove();
        }
      }
    });

  } catch (error) {
    console.error("Error fetching existing fires:", error);
  }
};